import { useMemo } from 'react';
import { SealQuestion, Plus } from '@phosphor-icons/react';
import { parseMessageContent } from '../../../../shared/utils/messageParser';

interface QuestionsMessageProps {
  content: string;
  onFollowUpQuestion: (question: string) => void;
}

export function QuestionsMessage({ content, onFollowUpQuestion }: QuestionsMessageProps) {
  const parsedContent = parseMessageContent(content);

  return (
    <div className="text-[#361E06]">
      <div className="flex items-center mb-6 gap-3">
        <SealQuestion className="w-6 h-6" weight="fill"/>
        <h3 className="font-medium text-lg">Follow-up questions</h3>
      </div>
      <div className="">
        {parsedContent.questions?.map((question, index) => (
          <button
            key={index}
            onClick={() => onFollowUpQuestion(question)}
                className="bg-[#F5F3F0] px-4 mb-2 rounded-lg flex justify-between items-center text-left py-3 font-medium leading-[1.65] w-full" 
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
}